import React from "react";

import ConnectedUserInfo from "@components/ConnectedUserInfo/ConnectedUserInfo";
import CreateModal from "@components/CreateModal/CreateModal";
import { createContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "../header";
import { Sidebar } from "../sideBar";
import "./index.scss";

export const CreateModalContext = createContext(null);

const AppLayout = ({ children }) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [createModalChildren, setCreateModalChildren] = useState(null);
  const [createModalTitle, setCreateModalTitle] = useState("");
  const [styleModal, setStyleModal] = useState("");
  const location = useLocation();

  const isSignaturePage = location.pathname.includes("/singature");
  console.log("ddd", isSignaturePage);
  const toggleCreateModal = (
    _createModalChildren,
    _createModalTitle,
    style
  ) => {
    setIsCreateModalOpen((prev) => !prev);
    setCreateModalChildren(_createModalChildren);
    setCreateModalTitle(_createModalTitle);
    setStyleModal(style);
  };

  return (
    <div className="app-layout">
      <CreateModalContext.Provider
        value={{ toggleCreateModal, isCreateModalOpen }}>
        <>
          <Header />

          <div className="app">
            <Sidebar />
            <div className={`main-content `}>
              <ConnectedUserInfo />

              <div
                className={`children-content `}
                style={
                  isSignaturePage
                    ? {} // pas de style si on est sur /signature
                    : {
                        transform: "scale(0.75)",
                        transformOrigin: "top left",
                        width: "133.25%",
                      }
                }>
                {" "}
                {children}
              </div>
            </div>
          </div>
        </>
      </CreateModalContext.Provider>
      {isCreateModalOpen && createModalChildren && (
        <CreateModal
          isOpen={isCreateModalOpen}
          toggleModal={toggleCreateModal}
          title={createModalTitle}
          style={styleModal}>
          {createModalChildren}
        </CreateModal>
      )}
    </div>
  );
};

export default AppLayout;
